import React, { Component } from 'react';

export default class CopyToClipBoardSvg extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="16"
        viewBox="0 0 14 16"
        fill="#E10098"
      >
        <path d="M10.0003 0.666504H2.00033C1.26699 0.666504 0.666992 1.2665 0.666992 1.99984V11.3332H2.00033V1.99984H10.0003V0.666504ZM12.0003 3.33317H4.66699C3.93366 3.33317 3.33366 3.93317 3.33366 4.6665V13.9998C3.33366 14.7332 3.93366 15.3332 4.66699 15.3332H12.0003C12.7337 15.3332 13.3337 14.7332 13.3337 13.9998V4.6665C13.3337 3.93317 12.7337 3.33317 12.0003 3.33317ZM12.0003 13.9998H4.66699V4.6665H12.0003V13.9998Z" />
      </svg>
    );
  }
}

